'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/5/20.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgetPassword = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('忘记密码')));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    changePwdUserInfo: state.auth.changePwdUserInfo
  };
}, authActions), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ForgetPassword, _Component);

  function ForgetPassword() {
    (0, _classCallCheck3.default)(this, ForgetPassword);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ForgetPassword).call(this));

    _this.state = {
      status: 'verifyUser',
      statusErrorMessage: ''
    };
    return _this;
  }

  (0, _createClass3.default)(ForgetPassword, [{
    key: 'onVerifyUserSubmit',
    value: function onVerifyUserSubmit(data) {
      var _this2 = this;

      var changePwdVerifyUser = this.props.changePwdVerifyUser;

      if (changePwdVerifyUser) {
        changePwdVerifyUser(data).then(function (resultData) {
          if (resultData && resultData.isValid) {
            _this2.setState({
              status: 'verifyMobile',
              statusErrorMessage: ''
            });
          } else {
            _this2.setState({
              statusErrorMessage: '用户不存在'
            });
          }
        });
      }
    }
  }, {
    key: 'onVerifyClick',
    value: function onVerifyClick(mobile) {
      var getCode = this.props.getCode;

      if (getCode) {
        getCode(mobile, '1', '1');
      }
    }
  }, {
    key: 'onVerifyMobileSubmit',
    value: function onVerifyMobileSubmit(data) {
      var _this3 = this;

      var changePwdVerifyMobile = this.props.changePwdVerifyMobile;

      if (changePwdVerifyMobile) {
        changePwdVerifyMobile(data).then(function (resultData) {
          if (resultData && resultData.isValid) {
            _this3.setState({
              status: 'changePwd',
              statusErrorMessage: ''
            });
          } else {
            _this3.setState({
              statusErrorMessage: '验证码不正确'
            });
          }
        });
      }
    }
  }, {
    key: 'onRealChangeSubmit',
    value: function onRealChangeSubmit(data) {
      var _this4 = this;

      var realChangePwd = this.props.realChangePwd;

      if (realChangePwd) {
        realChangePwd(data).then(function (resultData) {
          if (resultData && resultData.isValid) {
            _this4.setState({
              status: 'changed',
              statusErrorMessage: ''
            });
          } else {
            _this4.setState({
              statusErrorMessage: resultData.message
            });
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ChangeInfo.scss');
      var _state = this.state;
      var status = _state.status;
      var statusErrorMessage = _state.statusErrorMessage;
      var changePwdUserInfo = this.props.changePwdUserInfo;

      var contentDiv = '';
      var verifyUserClass = styles.titleItem;
      var verifyMobileClass = styles.titleItem;
      var newPwdClass = styles.titleItem;
      if (status === 'verifyUser') {
        contentDiv = _react2.default.createElement(_components.PersonalForgetPasswordVerifyUser, { onSubmit: this.onVerifyUserSubmit.bind(this) });
        verifyUserClass = verifyUserClass + ' ' + styles.titleActive;
      } else if (status === 'verifyMobile') {
        contentDiv = _react2.default.createElement(_components.PersonalForgetPasswordVerifyMobile, { getVerifyCode: this.onVerifyClick.bind(this),
          initialValues: changePwdUserInfo,
          onSubmit: this.onVerifyMobileSubmit.bind(this) });
        verifyMobileClass = verifyMobileClass + ' ' + styles.titleActive;
      } else if (status === 'changePwd') {
        contentDiv = _react2.default.createElement(_components.PersonalForgetPasswordRealChange, { onSubmit: this.onRealChangeSubmit.bind(this) });
        newPwdClass = newPwdClass + ' ' + styles.titleActive;
      }
      var content = _react2.default.createElement(
        'div',
        { className: styles.register_mes },
        _react2.default.createElement(
          'div',
          { className: styles.register_mes_inp },
          _react2.default.createElement(
            'div',
            { className: styles.mes_inp_tit },
            _react2.default.createElement(
              'span',
              { className: verifyUserClass },
              '用户验证'
            ),
            _react2.default.createElement(
              'span',
              { className: verifyMobileClass },
              '手机验证'
            ),
            _react2.default.createElement(
              'span',
              { className: newPwdClass },
              '新密码'
            )
          ),
          _react2.default.createElement('div', { className: styles.register_line, style: { marginLeft: '0px' } }),
          contentDiv,
          statusErrorMessage ? _react2.default.createElement(_components.ErrorLabel, { error: statusErrorMessage }) : ''
        ),
        _react2.default.createElement('img', { className: styles.register_bg, src: 'http://tupian.goeasy.cn:9999/yipinwang/register/register-bg1.png',
          alt: '' })
      );
      if (status === 'changed') {
        content = _react2.default.createElement(
          'div',
          { className: styles.register_mes },
          _react2.default.createElement(
            'div',
            { className: styles.submittedSucess },
            _react2.default.createElement('img', { className: styles.submittedSucesLogo, src: 'http://tupian.goeasy.cn:9999/yipinwang/logo.png', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: styles.submittedSucessTit },
              '艺品网提醒您'
            ),
            _react2.default.createElement(
              'p',
              { className: styles.submittedSucessContent },
              '密码重置成功'
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/login', className: styles.submittedSucesBtn },
              '立即登录'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'Center_gr', style: { marginTop: '19px', marginBottom: '45px' } },
        content
      );
    }
  }]);
  return ForgetPassword;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  changePwdUserInfo: _react.PropTypes.object,
  changePwdVerifyUser: _react.PropTypes.func,
  changePwdVerifyMobile: _react.PropTypes.func,
  changePasswordSubmit: _react.PropTypes.func,
  realChangePwd: _react.PropTypes.func,
  getCode: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ForgetPassword;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ChangeInfo/ForgetPassword.js
 ** module id = 1447
 ** module chunks = 0
 **/